import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { buildChildrenEffizienznetzwerkDokumentenablage, buildChildrenZusatztoolsDokumentenablage } from '../informationen_hilfe/sitemap/buildChildren'
import { ContextService } from '../../services/context_service';
import { DateiablageGalerie } from './DateiablageGalerie';
import { DateiablageVertraege } from './DateiablageVertraege';
import { DateiablageGebaeude } from './DateiablageGebaeude';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { hasEffizienznetzwerk } from '../helper';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import '../../css/tabs-bereiche.css';

interface DateiablageProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    onRoutingChange: (routing: any) => void;
    tabsClassName?: string;
}

interface DateiablageState {
    tabIndex: number;
}

export class Dateiablage extends React.Component<DateiablageProps, DateiablageState> {

    constructor(props: any) {
        super(props);
        this.tabIndexKey = `tabIdxDateiablage_${this.props.tabsClassName || '0'}`;
        this.state = {
            tabIndex: this.contextService.get(this.tabIndexKey) || 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private tabIndexKey: string;
    private viewNotice: JSX.Element = (
        <div style={{ fontSize: '9pt', fontStyle: 'italic', margin: '0 0 8px 2px' }}>
            Klicken Sie auf "+ Hinzufügen" um neue Unterlagen und Dokumente zu hinterlegen.
        </div>
    );

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        // const tabName: string = RoutingIDs.TABS_DATEIABLAGE;
        const tabName: string = this.props.tabsClassName === 'tabs-effizienznetzwerk'
            // ? RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE
            ? RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE
            : (this.props.tabsClassName === 'tabs-zusatztools' ? RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE : undefined);
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = this.props.tabsClassName === 'tabs-effizienznetzwerk'
                // ? RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE
                ? RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE
                : (this.props.tabsClassName === 'tabs-zusatztools' ? RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE : undefined);
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndexKey, tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const disabledEffizienznetzwerk: boolean = !hasEffizienznetzwerk(this.props.data) || this.props.tabsClassName !== 'tabs-effizienznetzwerk';
        if (disabledEffizienznetzwerk && this.state.tabIndex < 6) {
            this.setState({ tabIndex: 6 },
                () => this.contextService.set(this.tabIndexKey, this.state.tabIndex));
        }
        const tabRoutings = this.props.tabsClassName === 'tabs-effizienznetzwerk'
            ? buildChildrenEffizienznetzwerkDokumentenablage()
            : (this.props.tabsClassName === 'tabs-zusatztools' ? buildChildrenZusatztoolsDokumentenablage() : []);

        return (
            <Tabs
                className={this.props.tabsClassName || null}
                style={{ flex: 1, flexDirection: 'column', display: 'flex', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set(this.tabIndexKey, this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Netzwerk-Informationen', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Dokumente Teilnahme', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Betriebsberatung', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Veranstaltungen', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Monitoring', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Sonstiges (Netzwerk)', 'tab')}</Tab>
                    <Tab>{i18n('Verträge', 'tab')}</Tab>
                    <Tab>{i18n('Kommunikation', 'tab')}</Tab>
                    <Tab>{i18n('Genehmigungen/Zulassungen', 'tab')}</Tab>
                    <Tab>{i18n('Gebäude', 'tab')}</Tab>
                    <Tab>{i18n('Sonstiges', 'tab')}</Tab>
                </TabList>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 0 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_netzwerk_informationen'}
                        name={'Netzwerk-Informationen'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 1 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_dokumente_teilnahme'}
                        name={'Dokumente Teilnahme'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 2 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_betriebsberatung'}
                        name={'Betriebsberatung'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 3 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_veranstaltungen'}
                        name={'Veranstaltungen'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 4 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_monitoring'}
                        name={'Monitoring'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 5 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_sonstiges_netzwerk'}
                        name={'Sonstiges (Netzwerk)'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 6 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageVertraege
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        tabsClassName={this.props.tabsClassName}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 7 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_kommunikation'}
                        name={'Kommunikation'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 8 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_genehmigungen_zulassungen'}
                        name={'Genehmigungen/Zulassungen'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 9 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGebaeude
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        tabsClassName={this.props.tabsClassName}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 10 ? 1 : 0 }}>
                    {getDefaultHelpIcon('pageDateiablage', 'Hilfe zur Dateiablage', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_sonstiges'}
                        name={'Sonstiges'}
                        viewNotice={this.viewNotice}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
